import { postUrl } from '@/apiCalls/fetch';
import { selectIsNZ } from '@/context/display';
import { store } from '@/context/store';

export type ILookupSuburbOrPostcodeResponse = {
    predictions: {
        description: string;
        place_id: string;
        reference: string;
    }[];
};

export async function getLocationOptions(
    input: string
): Promise<ILookupSuburbOrPostcodeResponse> {
    const state = store.getState();
    const managePartnerToBillId =
        state.displayReducer.partner.manageOrganisationId;
    const isNZ = selectIsNZ(state);

    const url = `/api/google/lookupSuburbOrPostcode`;
    const response = await postUrl<ILookupSuburbOrPostcodeResponse>(url, {
        input,
        countryCode: isNZ ? 'NZ' : 'AU',
        managePartnerToBillId,
    });
    return response;
}
